import { getFlowConfig, getFlowSteps } from '../../flow-initial/getFlowConfig';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { isPostVerification } from '../../flow-settings/settingsSelectors';
import { isTransitionAndAnimationsDisabled } from '../../selenium/seleniumFeatures';
import { Data } from '../../signup-data/DATA';
import { ACQ134Industry, Industry } from '../../signup-data/IndusrtyOption';
import { getExistingUserStep } from '../../step-existing-user/existingUserUtils';
import { getWhichOAuthSelected } from '../../store/app/selectors';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { getParameter } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { getCurrentStep } from '../../store/flow/selectors';
import { setSignupDataValue } from '../../store/signup-data/action-creators';
import { Tracker } from '../../store/tracking/action-creators';
import { getIsMobile } from '../../utils/deviceUtils';
import { Step } from '../../views/Step';
import { ExperimentKeys } from '../ExperimentKeys';
import { ExperimentParameterGroup } from '../ExperimentParameterGroup';
export const shouldUseAnimationsACQ134 = state => {
  const currentStep = getCurrentStep(state);
  return currentStep === Step.HubOption && !getIsMobile() && !isTransitionAndAnimationsDisabled();
};
export const industryCollectionMethod = industryInput => {
  return industryInput ? 'input' : 'button';
};
export const acq134ExistingUserPreVerificationSteps = [Step.LandingPage, Step.CodeVerification];
export const acq134ExistingUserVariantBPostVerificationSteps = [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
const acq134VariantAPostVerificationSteps = [Step.Password, Step.Name, Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.HubOption, Step.BusinessGoals, Step.AhaMoment, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
export const getACQ134VariantAPostVerificationSteps = () => {
  let steps = acq134VariantAPostVerificationSteps;

  if (!getIsMobile()) {
    steps = NextStepManager.removeSteps(Step.HubOption)(steps);
  }

  return steps;
};
export const preFillHubInterestACQ134 = dispatch => {
  if (!getIsMobile()) {
    dispatch(setSignupDataValue(Data.HubOption, getFlowConfig().hubInterest));
    dispatch(setSignupDataValue(Data.HubInterest, getFlowConfig().hubInterest));
  }
};
export const setupAuthForOAuthExistingUserACQ134 = (state, dispatch) => {
  const preVerification = acq134ExistingUserPreVerificationSteps;
  let postVerification;
  const parameter = getParameter(state, ExperimentKeys.ACQ0134);
  const oAuthProviderSelected = getWhichOAuthSelected(state);
  dispatch(Tracker.signupInteraction(`${ExperimentKeys.ACQ0134}-${oAuthProviderSelected}-oauth-existing-user-${parameter}`));

  if (parameter === ExperimentParameterGroup.Variant_A) {
    postVerification = getACQ134VariantAPostVerificationSteps();
  } else if (parameter === ExperimentParameterGroup.Variant_B) {
    postVerification = acq134ExistingUserVariantBPostVerificationSteps;
  }

  let nextSteps = [...preVerification, ...postVerification];

  if (getIsAuthenticated(state) && !isPostVerification()) {
    nextSteps = NextStepManager.pushNextSteps(getExistingUserStep())(nextSteps);
  }

  dispatch(setFlow(nextSteps, preVerification, postVerification, [], getFlowSteps().postExistingAccountSelection));
};
export const acq134IndustryToIndustryMapping = {
  [ACQ134Industry.TechnologyAndServices]: Industry.TechnologyAndServices,
  [ACQ134Industry.Education]: Industry.Education,
  [ACQ134Industry.Consulting]: Industry.Consulting
};